import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaUserShield, FaDatabase, FaClipboardList, } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";


const PolitiqueConfidentialite = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, mirror: true, once: false });

        // Scroll to top on component mount
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header/>
            <div className="privacy-page">
                {/* Hero Section */}
                <section className="hero-section py-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 text-center" data-aos="fade-up">
                                <h1 className="fw-bold mb-4">
                                    Politique de <span className="gradient-text">Confidentialité</span>
                                </h1>
                                <p className="lead mb-0">
                                    Nous nous engageons à protéger vos données personnelles avec le plus grand soin.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Main Content */}
                <section className="privacy-content py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card shadow-sm mb-5" data-aos="fade-up">
                                    <div className="card-body p-4 p-md-5">
                                        <div className="intro-section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">1. Introduction</h2>
                                            <p data-aos="fade-up">
                                                Dans le cadre de son activité d'expertise comptable, Cinef-Expertise est amenée
                                                à collecter et traiter des données à caractère personnel relatives à ses clients,
                                                prospects, partenaires et utilisateurs de son site internet.
                                            </p>
                                            <p data-aos="fade-up">
                                                La présente politique de confidentialité a pour objet de vous informer sur les
                                                conditions dans lesquelles nous collectons, utilisons et protégeons vos données
                                                personnelles, conformément au Règlement Général sur la Protection des Données (RGPD)
                                                ainsi qu'à toute législation nationale applicable en matière de protection des données.
                                            </p>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise s'engage à respecter la confidentialité des données personnelles
                                                collectées et à les traiter avec la plus grande attention.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">2. Responsable du traitement</h2>
                                            <p data-aos="fade-up">
                                                Les données à caractère personnel collectées sur le site www.cinef-expertise.com
                                                sont traitées par :
                                            </p>
                                            <div className="bg-light p-4 rounded mb-4" data-aos="fade-up">
                                                <p className="mb-2"><strong>Cinef-Expertise</strong></p>
                                                <p className="mb-2">Sainte Rita, Cotonou - Bénin</p>
                                                <p className="mb-2">Email : dpo@cinef-expertise.com</p>
                                                <p className="mb-0">Téléphone : +229 01 97 08 46 01</p>
                                            </div>
                                            <p data-aos="fade-up">
                                                Pour toute question relative à la protection de vos données personnelles,
                                                vous pouvez contacter notre Délégué à la Protection des Données à l'adresse
                                                suivante : dpo@cinef-expertise.com.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">3. Données collectées</h2>
                                            <p data-aos="fade-up">
                                                Dans le cadre de notre activité et de l'utilisation de notre site internet,
                                                nous pouvons être amenés à collecter les catégories de données suivantes :
                                            </p>
                                            <ul data-aos="fade-up">
                                                <li className="mb-3">
                                                    <strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone,
                                                    fonction, entreprise
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Données professionnelles :</strong> raison sociale, numéro SIRET, adresse
                                                    du siège social, secteur d'activité
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Données de connexion :</strong> adresse IP, cookies, date et heure de connexion
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Données financières et comptables :</strong> dans le cadre de nos prestations
                                                    d'expertise comptable (bilans, comptes de résultat, déclarations fiscales, etc.)
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Données de communication :</strong> échanges de courriers électroniques,
                                                    demandes d'information, commentaires
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">4. Finalités du traitement</h2>
                                            <p data-aos="fade-up">
                                                Nous collectons et traitons vos données personnelles pour les finalités suivantes :
                                            </p>
                                            <div className="table-responsive" data-aos="fade-up">
                                                <table className="table table-striped">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th>Finalités</th>
                                                            <th>Base légale</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Exécution des missions d'expertise comptable, fiscale et sociale</td>
                                                            <td>Exécution d'un contrat</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Gestion de la relation client (suivi des dossiers, facturation)</td>
                                                            <td>Exécution d'un contrat</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Réponse aux demandes d'information et de contact</td>
                                                            <td>Consentement / Intérêt légitime</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Envoi de communications et newsletters</td>
                                                            <td>Consentement</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Amélioration de nos services et de notre site internet</td>
                                                            <td>Intérêt légitime</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Respect des obligations légales et réglementaires</td>
                                                            <td>Obligation légale</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">5. Destinataires des données</h2>
                                            <p data-aos="fade-up">
                                                Vos données personnelles sont destinées aux services internes de Cinef-Expertise
                                                habilités à les traiter. Elles peuvent également être transmises à des tiers dans
                                                les cas suivants :
                                            </p>
                                            <ul data-aos="fade-up">
                                                <li className="mb-3">
                                                    <strong>Sous-traitants :</strong> prestataires techniques (hébergement, maintenance informatique),
                                                    prestataires de services (logiciels comptables)
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Partenaires :</strong> autres professionnels intervenant dans le cadre de nos missions
                                                    (avocats, notaires, commissaires aux comptes)
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Autorités publiques :</strong> administration fiscale, organismes sociaux,
                                                    dans le cadre des obligations légales
                                                </li>
                                            </ul>
                                            <p data-aos="fade-up">
                                                Nous veillons à ce que ces tiers présentent des garanties suffisantes pour assurer
                                                la protection de vos données personnelles.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">6. Durée de conservation</h2>
                                            <p data-aos="fade-up">
                                                Nous conservons vos données personnelles pour une durée limitée, déterminée en
                                                fonction des finalités pour lesquelles elles ont été collectées :
                                            </p>
                                            <div className="table-responsive" data-aos="fade-up">
                                                <table className="table table-striped">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th>Type de données</th>
                                                            <th>Durée de conservation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Données relatives aux clients</td>
                                                            <td>10 ans à compter de la fin de la relation contractuelle</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Données comptables et fiscales</td>
                                                            <td>10 ans à compter de la clôture de l'exercice</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Données des prospects</td>
                                                            <td>3 ans à compter du dernier contact</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Données de connexion</td>
                                                            <td>13 mois</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">7. Vos droits</h2>
                                            <p data-aos="fade-up">
                                                Conformément à la réglementation en vigueur, vous disposez des droits suivants
                                                concernant vos données personnelles :
                                            </p>
                                            <div className="row" data-aos="fade-up">
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit d'accès</h5>
                                                            <p className="card-text">Vous pouvez obtenir la confirmation que des données vous concernant sont traitées et en obtenir une copie.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit de rectification</h5>
                                                            <p className="card-text">Vous pouvez demander la correction des données inexactes ou incomplètes.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit à l'effacement</h5>
                                                            <p className="card-text">Vous pouvez demander la suppression de vos données dans certaines conditions.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit à la limitation</h5>
                                                            <p className="card-text">Vous pouvez demander la limitation du traitement de vos données.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit à la portabilité</h5>
                                                            <p className="card-text">Vous pouvez récupérer vos données dans un format structuré.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="card h-100 privacy-card">
                                                        <div className="card-body">
                                                            <h5 className="card-title fw-bold">Droit d'opposition</h5>
                                                            <p className="card-text">Vous pouvez vous opposer au traitement de vos données pour des motifs légitimes.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="mt-4" data-aos="fade-up">
                                                Pour exercer ces droits, vous pouvez nous contacter par email à l'adresse suivante :
                                                privacy@cinef-expertise.com ou par courrier à l'adresse du cabinet.
                                            </p>
                                            <p data-aos="fade-up">
                                                Vous disposez également du droit d'introduire une réclamation auprès de l'autorité
                                                de contrôle compétente en matière de protection des données personnelles.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">8. Sécurité des données</h2>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise met en œuvre des mesures techniques et organisationnelles appropriées
                                                afin de garantir un niveau de sécurité adapté au risque, notamment :
                                            </p>
                                            <ul data-aos="fade-up">
                                                <li className="mb-2">Chiffrement des données sensibles</li>
                                                <li className="mb-2">Contrôle des accès aux données</li>
                                                <li className="mb-2">Sauvegarde régulière des données</li>
                                                <li className="mb-2">Formation du personnel à la protection des données</li>
                                                <li className="mb-2">Mise à jour des logiciels et systèmes de sécurité</li>
                                            </ul>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">9. Cookies et technologies similaires</h2>
                                            <p data-aos="fade-up">
                                                Notre site utilise des cookies et autres technologies similaires pour améliorer
                                                votre expérience de navigation, analyser l'utilisation du site et personnaliser
                                                nos services.
                                            </p>
                                            <p data-aos="fade-up">
                                                Les types de cookies utilisés sont les suivants :
                                            </p>
                                            <ul data-aos="fade-up">
                                                <li className="mb-2"><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site</li>
                                                <li className="mb-2"><strong>Cookies analytiques :</strong> permettent de suivre les statistiques de visite</li>
                                                <li className="mb-2"><strong>Cookies de fonctionnalité :</strong> améliorent l'expérience utilisateur</li>
                                                <li className="mb-2"><strong>Cookies de ciblage :</strong> permettent d'afficher des publicités pertinentes (le cas échéant)</li>
                                            </ul>
                                            <p data-aos="fade-up">
                                                Vous pouvez gérer vos préférences en matière de cookies à tout moment en configurant
                                                les paramètres de votre navigateur ou en utilisant notre bandeau de gestion des cookies.
                                            </p>
                                        </div>

                                        <div className="section">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">10. Modifications de la politique de confidentialité</h2>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise se réserve le droit de modifier la présente politique de confidentialité
                                                à tout moment. Les modifications entrent en vigueur dès leur publication sur le site.
                                            </p>
                                            <p data-aos="fade-up">
                                                Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance
                                                des éventuelles modifications. La date de dernière mise à jour figure en bas de page.
                                            </p>
                                            <p className="text-muted mt-5 text-center" data-aos="fade-up">
                                                Dernière mise à jour : Mai 2025
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Privacy Icons */}
                                <div className="row privacy-icons mb-5">
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up">
                                        <FaUserShield className="privacy-icon mb-3" />
                                        <h5 className="fw-bold">Protection Maximale</h5>
                                        <p>Nous protégeons vos données avec les plus hauts standards de sécurité.</p>
                                    </div>
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up" data-aos-delay="100">
                                        <FaDatabase className="privacy-icon mb-3" />
                                        <h5 className="fw-bold">Données Sécurisées</h5>
                                        <p>Vos informations financières et personnelles sont stockées de manière sécurisée.</p>
                                    </div>
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up" data-aos-delay="200">
                                        <FaClipboardList className="privacy-icon mb-3" />
                                        <h5 className="fw-bold">Transparence Totale</h5>
                                        <p>Nous vous expliquons clairement comment vos données sont utilisées.</p>
                                    </div>
                                </div>

                                {/* Contact Section */}
                                <div className="contact-box text-center p-4 rounded" data-aos="zoom-in">
                                    <h3 className="fw-bold mb-3">Des questions sur vos données ?</h3>
                                    <p className="mb-4">Notre Délégué à la Protection des Données est à votre écoute pour toute question relative à la confidentialité.</p>
                                    <a href="mailto:privacy@cinef-expertise.com" className="cta-button">Contactez notre DPO ↗</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <style>{`
                .hero-section {
                    background: linear-gradient(rgba(42, 119, 255, 0.05), rgba(230, 57, 70, 0.05));
                    padding: 80px 0;
                }

                .gradient-text {
                    background: linear-gradient(to right, #008a44, #dc3545);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .privacy-content {
                    background-color: #f8f9fa;
                }

                .card {
                    border: none;
                    border-radius: 15px;
                }

                h2 {
                    color: #008a44;
                    border-left: 4px solid #e63946;
                    padding-left: 15px;
                }

                .privacy-icon {
                    font-size: 50px;
                    color: #e63946;
                }

                .contact-box {
                 background: linear-gradient(45deg, #008a44, #e63946);
                  color: white;
                 width: 60%;              /* Réduit la largeur à 60% du parent */
                 margin: 0 auto;          /* Centre horizontalement */
                 padding: 20px;           /* Optionnel : ajoute un peu d'espace intérieur */
                 border-radius: 8px;      /* Optionnel : arrondit les bords */
                }


                .cta-button {
                    background-color: white;
                    color: #2a77ff;
                    padding: 12px 24px;
                    border-radius: 50px;
                    font-weight: bold;
                    text-decoration: none;
                    display: inline-block;
                    transition: transform 0.3s ease-in-out;
                }

                .cta-button:hover {
                    transform: scale(1.1);
                    background-color: #f8f9fa;
                }

                .privacy-card {
                    transition: all 0.3s ease;
                    border: none;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                }

                .privacy-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
                }

                .table-primary {
                    background-color: rgba(42, 119, 255, 0.1);
                }

                .table {
                    border-radius: 8px;
                    overflow: hidden;
                }

                @media (max-width: 768px) {
                    .hero-section {
                        padding: 50px 0;
                    }
                    
                    h1 {
                        font-size: 2rem;
                    }
                    
                    h2 {
                        font-size: 1.5rem;
                    }
                }
            `}</style>
            </div>
            <Footer/>
        </>
    );
};

export default PolitiqueConfidentialite;